export var MapBackend;

(function (MapBackend) {
  MapBackend[MapBackend["MAPBOX"] = 0] = "MAPBOX";
  MapBackend[MapBackend["CESIUM"] = 1] = "CESIUM";
  MapBackend[MapBackend["MAPBOX3"] = 2] = "MAPBOX3";
})(MapBackend || (MapBackend = {}));

export var MapLayer;

(function (MapLayer) {
  MapLayer["SATELLITE"] = "satellite";
  MapLayer["LINES"] = "lines";
  MapLayer["COLUMNS"] = "columns";
  MapLayer["FOSSILS"] = "fossils";
  MapLayer["BEDROCK"] = "bedrock";
  MapLayer["SOURCES"] = "sources";
  MapLayer["LABELS"] = "labels";
  MapLayer["LINE_SYMBOLS"] = "line-symbols";
})(MapLayer || (MapLayer = {}));

export var PositionFocusState;

(function (PositionFocusState) {
  PositionFocusState[PositionFocusState["CENTERED"] = 0] = "CENTERED";
  PositionFocusState[PositionFocusState["NEAR_CENTER"] = 1] = "NEAR_CENTER";
  PositionFocusState[PositionFocusState["OFF_CENTER"] = 2] = "OFF_CENTER";
  PositionFocusState[PositionFocusState["OUT_OF_PADDING"] = 3] = "OUT_OF_PADDING";
  PositionFocusState[PositionFocusState["OUT_OF_VIEW"] = 4] = "OUT_OF_VIEW";
})(PositionFocusState || (PositionFocusState = {}));